// Loads Swiper and its LESS.
// This allows the LESS to be bundled with the JS for a single dynamic inclusion at runtime.

// Relative paths prevent webpack resolve alias from remapping the imports,
// and causing `RangeError: Maximum call stack size exceeded` during build.
import Swiper from '../node_modules/swiper'
import '../node_modules/swiper/swiper.less'
import './swiper-custom.less'

export default Swiper
